import { useMemo } from "react";
import { ANIMATION_SPEEDS } from "../components/design-tokens";

export const useLoadingTiming = (interval: number) => {
  return useMemo(() => {
    const normalizedInterval = Math.max(1000, Math.round(interval / 2) * 2);
    const pulseDuration = Math.round(normalizedInterval / 4);
    const fadeDelay = Math.round(ANIMATION_SPEEDS.STANDARD / 2);

    return { normalizedInterval, pulseDuration, fadeDelay };
  }, [interval]);
};
